import { render, staticRenderFns } from "./BinsPermissions.vue?vue&type=template&id=60000372&scoped=true"
import script from "./BinsPermissions.vue?vue&type=script&lang=js"
export * from "./BinsPermissions.vue?vue&type=script&lang=js"
import style0 from "./BinsPermissions.vue?vue&type=style&index=0&id=60000372&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60000372",
  null
  
)

export default component.exports